import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconExternalOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M12.333 4a1 1 0 1 1 0 2H6v20h20v-6.333a1 1 0 1 1 2 0V27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" /><path fill="currentColor" d="M27 4a1 1 0 0 1 1 1v8.667a1 1 0 0 1-2 0V7.414L15.374 18.04a1 1 0 1 1-1.414-1.414L24.586 6h-6.253a1 1 0 0 1 0-2z" /></svg>;
export default SvgIconExternalOutlined;